import React from 'react';
import classNames from 'classnames';
import './ErrorPage.scss';

const ErrorPage = ({className, children}) => {
    return (
        <div className={classNames('error-page', className)}>
            {children}
        </div>
    );
};

export default ErrorPage;


// WEBPACK FOOTER //
// ./src/containers/template/ErrorPage.js